import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  container: {
    alignItems: 'center',
    borderBottom: '1px solid #E3E4E5',
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '1rem',
    padding: '0.5rem 0'
  },
  innerContainer: {
    alignItems: 'center',
    display: 'flex'
  },
  copy: {
    color: '#74767C',
    fontSize: '1rem',
    lineHeight: '1.5rem'
  },
  icon: {
    marginRight: '1rem'
  }
}));
